module.exports = __webpack_public_path__ + "media/campaigns/confetti-image-a9835f03.png";